//
//
//
//
import effectScatter from '@/components/bigDataChart/effectScatter';
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title'; // import { querySewageQuota } from '@/api/api'
// import { listenMapChange } from '@/mixins/listenMapChange'

export default {
  name: 'servicePopulation',
  //   mixins: [listenMapChange],
  created: function created() {
    this.queryWaterType();
  },
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    dataMap: {
      type: Object,
      default: {}
    }
  },
  components: {
    effectScatter: effectScatter
  },
  methods: {
    queryWaterType: function queryWaterType(areaId, projectId) {
      var _this = this;

      setTimeout(function () {
        console.log(_this.dataMap, "this.dataMap");
        var datalist = [{
          offset: [70, 65],
          symbolSize: 50,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#29c0fb'
          }, {
            offset: 1,
            color: '#2dc5b9'
          }])
        }, {
          offset: [50, 80],
          symbolSize: 50,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#35d17e'
          }, {
            offset: 1,
            color: '#49ddb2'
          }])
        }, {
          offset: [30, 43],
          symbolSize: 80,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#e5d273'
          }, {
            offset: 1,
            color: '#e4a37f'
          }])
        }, {
          offset: [65, 25],
          symbolSize: 60,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#277aec'
          }, {
            offset: 1,
            color: '#57c5ec'
          }])
        } // {
        //   offset: [85, 45],
        //   symbolSize: 75,
        //   opacity: 0.7,
        //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //     {
        //       offset: 0,
        //       color: '#11c46e',
        //     },
        //     {
        //       offset: 1,
        //       color: '#f08456',
        //     },
        //   ]),
        // },
        ];
        var data = [{
          name: '上游液位(水位)',
          value: _this.dataMap['u21701'].value + "m"
        }, {
          name: '下游液位(水位)',
          value: _this.dataMap['u21801'].value + " m"
        }, // {
        //   name: '面积',
        //   value: this.dataMap['u20401'].value+ " ㎡",
        // },
        {
          name: '橡胶坝高度',
          value: _this.dataMap['u21601'].value + " m"
        }, {
          name: '管道压力',
          value: _this.dataMap['u22401'].value + " Kpa"
        }];

        _this.$refs.chart1.initEffectScatterChart(data, datalist);
      }, 1000);
    }
  } //   watch: {
  //     currentProjectId(value) {
  //       this.queryWaterType(this.currentAreaId, value)
  //     },
  //     currentAreaId(value) {
  //       this.queryWaterType(value, this.currentProjectId)
  //     },
  //   },

};